module.exports = __webpack_public_path__ + "img/5ac_39.d097b411.gif";